import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { withStyles } from '@material-ui/core';
import { TextField } from 'formik-material-ui';
import Typography from '@material-ui/core/Typography';
import { Formik, Field, Form } from 'formik';

import StepContainer from '../steps/StepContainer';
import styles from '../steps/stepsstyles';
import CompositeAlert from '../../core/CompositeAlert';
import Fieldset from '../../core/Fieldset';
import FormItem from '../../core/FormItem';
import { validationSchema } from './validationSchema';

class CaptureDirector extends PureComponent {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleSubmit(values, { setSubmitting }) {
    const callback = () => {
      setSubmitting(false);
    };
    this.props.createLead(values, callback);
  }

  render() {
    const { formInitialValues } = this.props;

    return (
      <Formik
        enableReinitialize
        validateOnBlur={false}
        initialValues={formInitialValues}
        validationSchema={validationSchema}
        onSubmit={this.handleSubmit}
        render={({ submitForm, isSubmitting, dirty, errors }) => (
          <Form autoComplete="off">
            <Fieldset disabled={isSubmitting}>
              <StepContainer
                title="Your personal details"
                isSubmitVisible
                isSubmitDisabled={isSubmitting || !dirty || Object.keys(errors).length > 0}
                onSubmit={submitForm}
              >
                <Grid container item xs={12} spacing={2}>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1">Enter your full name below</Typography>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <FormItem label="First name">
                      <Field
                        type="text"
                        name="firstName"
                        component={TextField}
                        variant="outlined"
                        fullWidth
                        data-testid="firstName"
                      />
                    </FormItem>
                  </Grid>
                  <Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
                    <FormItem label="Last name">
                      <Field
                        type="text"
                        name="lastName"
                        component={TextField}
                        variant="outlined"
                        fullWidth
                        data-testid="lastName"
                      />
                    </FormItem>
                  </Grid>
                  {!this.props.isLeadCreated && this.props.errorMessage.length > 0 && (
                    <Grid item xs={12}>
                      <CompositeAlert
                        variant="error"
                        message={this.props.errorMessage}
                        data-testid="error"
                      />
                    </Grid>
                  )}
                </Grid>
              </StepContainer>
            </Fieldset>
          </Form>
        )}
      />
    );
  }
}

CaptureDirector.propTypes = {
  createLead: PropTypes.func.isRequired,
  isLeadCreated: PropTypes.bool,
  errorMessage: PropTypes.string,
  formInitialValues: PropTypes.shape({
    firstName: PropTypes.string,
    lastName: PropTypes.string,
  }),
};

CaptureDirector.defaultProps = {
  isLeadCreated: false,
  errorMessage: '',
  formInitialValues: {
    firstName: '',
    lastName: '',
  },
};

export default withStyles(styles)(CaptureDirector);
